<template>
  <div class="container">
    <h2 class="mb-5">Manage sector submissions</h2>
    <div class="row">
      <!-- <div class="col-md-6"></div>
      <div class="col-md-6">
        <base-select
          name="company"
          v-model="company"
          :options="userCompanies"
          col1="col-sm-0" col2="col-sm-12"
          select-label="name"
        ></base-select>
      </div> -->
    </div>
      <table class="table table-bordered table-condensed tooltips">
        <thead>
          <tr>
            <th>Field of activity</th>
            <th>Submission Date</th>
            <th>Internal Pre-consumer waste (T)</th>
            <th>Volume uptake of recyclate that is acquired from external sources</th>
            <th style="width: 200px;">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(submission, index) in paginatedSubmissions"
            :key="index"
          >
            <td>
              {{getSubmissionName(sectorAssociation.name_id)}}
            </td>
            <td>
              {{ [submission.year, 'YYYY'] | moment('YYYY') }}
            </td>
            <td>
              {{ sumInternalQuarterArray(submission) }}
            </td>
            <td>
              {{ sumExternalQuarterArray(submission) }}
            </td>
            <td>
              <span
                class="action-icon"
                title="Edit submission"
                @click="$router.push({ name: 'user.edit-submission-sector-association-representative', params: { year: submission.year } })"
              >
                <i class="fas fa-pen"></i>
              </span>
              <span
                class="action-icon"
                title="Assign End Applications"
                @click="$router.push({ name: 'user.manage-region-application', params: { year: submission.year } })"
              >
                Assign volume to region/country
              </span>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="row">
        <div class="col-4"></div>
        <div class="col-8 text-right">
          <r-pagination
            :totalPages="totalPages"
            :total="total"
            :currentPage="currentSubmissionsPage"
            @pageChanged="handlePageChanged"
          />
        </div>
     </div>
    <div class="row">
      <div class="col-md-6">
        <base-button radius="bl" component-class="blue" @click.native="$router.push({ name: 'user.dashboard' })">
          <i class="fas fa-arrow-left mr-3"></i> Back
        </base-button>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex';
  import * as moment from 'moment';
  import Pagination from '@/components/Pagination/Pagination';
  import BaseButton from '@/components/inputs/button/BaseButton';
  import { sumArray } from '@/helpers/math';
  import constances from '@/configs/constances';

  export default {
    data() {
      return {
        itemsPerPage: 5,
        currentSubmissionsPage: 1,
        company: { id: null },
      };
    },

    computed: {
      ...mapState({
        // userCompanies: state => state.userCompanies.loggedUserCompanies,
        sectorAssociation: state => state.user.sectorAssociation,
      }),
      sectorSubmissions() {
        const { company } = this;
        const groupedSectorSubmissions = this.$store.getters['userSectorSubmissions/groupedSectorSubmissions'];
        if (company && company.id) {
          return Object.values(groupedSectorSubmissions)
            .filter((submission) => submission.company_id === company.id);
        }
        return Object.values(groupedSectorSubmissions);
      },
      paginatedSubmissions() {
          const skipUsersSubmissions = this.currentSubmissionsPage === 1 ? 0 : (this.currentSubmissionsPage - 1) * this.itemsPerPage;
          return this.sectorSubmissions.slice(skipUsersSubmissions, skipUsersSubmissions + this.itemsPerPage);
      },
      total() {
        return this.sectorSubmissions.length;
      },
      totalPages() {
          return Math.ceil(this.total / this.itemsPerPage);
      },
    },

    watch: {
      company() {
        this.currentSubmissionsPage = 1;
      },
    },

    methods: {
      ...mapActions({
        // getUserAttachedCompany: 'userCompanies/getUserAttachedCompany',
        getUserSectorSubmissions: 'userSectorSubmissions/getUserSectorSubmissions',
        getUserSectorAssociation: 'user/getUserSectorAssociation',
      }),
      sumInternalQuarterArray(submission) {
          const { iq1, iq2, iq3, iq4 } = submission;
          return sumArray([iq1, iq2, iq3, iq4]) || '-';
      },
      sumExternalQuarterArray(submission) {
          const { eq1, eq2, eq3, eq4 } = submission;
          return sumArray([eq1, eq2, eq3, eq4]) || '-';
      },
      getSubmissionName(id) {
          const name = Object.keys(constances.sectorAssociation)
                        .find(key => constances.sectorAssociation[key].id === id);
          return name;
      },
      getAcceptedDate(submission) {
        if (!submission.accepted_date) {
          return '-- not accepted --';
        }
        return moment(submission.accepted_date).format('YYYY-MM-DD');
      },
      handlePageChanged(page) {
        this.currentSubmissionsPage = page;
      },
    },

    async mounted () {
      await this.getUserSectorAssociation(this.$store.getters['user/getLoggedInUserId']);
      await this.getUserSectorSubmissions();
        // await this.getUserSectorAssociation();
        // this.getUserAttachedCompany(this.$store.getters['user/getLoggedInUserId']);
    },

    components: {
      'base-button': BaseButton,
      'r-pagination': Pagination,
    }
  };

</script>
